import { render, staticRenderFns } from "./DictDeleteList.vue?vue&type=template&id=d7d78a24&scoped=true&"
import script from "./DictDeleteList.vue?vue&type=script&lang=js&"
export * from "./DictDeleteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d78a24",
  null
  
)

export default component.exports